import type { UseExploreItemsParams, UseExploreNearbyItemsParams } from '../api/exploreParams'

export const all = ['tripExplore'] as const
export const items = (params: UseExploreItemsParams) =>
  [...all, 'items', params] as const
export const nearbyItems = (params: UseExploreNearbyItemsParams) =>
  [...all, 'nearbyItems', params] as const
